export default "__VITE_ASSET__6f0e5c9f__"